import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { slideDownUp } from '../global-app-animations';

@Component({
    selector: 'app-custom-date-picker',
    templateUrl: './custom-date-picker.component.html',
    styleUrls: ['./custom-date-picker.component.scss'],
    providers: [
        DatePipe
    ],
    animations: [slideDownUp],
    standalone: false
})
export class CustomDatePickerComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('inputEl') inputEl: HTMLInputElement | undefined;
  @ViewChild('datePicker') dateEl: HTMLInputElement | undefined;

  // form inputs
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup ;
  
  // inputs
  @Input() dateFormat: 'date' | 'time' | 'datetime-local' | undefined;
  @Input() fieldId: string | undefined;

  format: string = "datetime-local";

  parsedDateFormat: string = "date";
  parsedFieldId: string = "";

  dateValue: string = "";

  @Output() changeValue: EventEmitter<any>= new EventEmitter<any>();
  @Output() keyUp: EventEmitter<any> = new EventEmitter<any>();
  

  constructor(
    private datePipe: DatePipe,
  ) {
   
  }

  ngOnInit(): void {
    /*console.warn(this.field);
    console.warn(this.group);*/
    if(this.field != undefined) {
      if(this.field.type == 'date') {
        this.format = 'date';
        this.group.get(this.field.name)!.setValue(this.datePipe.transform(this.group.get(this.field.name)?.value, 'yyyy-MM-dd'));
      }else if(this.field.type == 'time'){
        this.format = 'time';
        this.group.get(this.field.name)!.setValue(this.datePipe.transform(this.group.get(this.field.name)?.value, 'HH:mm'));
      }else{
        this.format = 'datetime-local';
        this.group.get(this.field.name)!.setValue(this.datePipe.transform(this.group.get(this.field.name)?.value, 'yyyy-MM-ddTHH:mm'));
      }
    }
   
    if(this.fieldId == undefined) {
      this.parsedFieldId = "date-picker-custom";
    }else{
      this.parsedFieldId = this.fieldId;
    }

    if(this.dateFormat == undefined) {
      this.dateFormat = 'date';
      this.parsedDateFormat = this.dateFormat;
    }
    
  }

  ngAfterViewInit(): void {
    // imposto autofocus se serve
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      document.getElementById(this.field.name)!.focus();
    }*/
  }

  ngOnChanges(change: {something: SimpleChange, dateTipe: SimpleChange}): void {
    // to do change date when field change
    /********************************************************************************************/
  }

  // event on focus
  onFocus(event:any) {
    const elem = event.target || event.srcElement;
    elem.select();
  }

  // changes emitter
  onChangeValue(event: any) {
    this.changeValue.emit(event);
  }

  clearDate(e:any) {
    this.dateValue = "";
    this.keyUp.emit(this.dateEl);
  }

  pushValue(e:any) {    
    console.warn("keyup on date")
    console.warn(e);
    this.keyUp.emit(e);
    return;
    /*if(this.parsedDateFormat == 'date'){
      this.keyUp.emit({
        data:  this.datePipe.transform(this.dateValue, 'yyyy-MM-dd'),
        event: e,
      });
    }else if(this.parsedDateFormat == 'time'){
      this.keyUp.emit({
        data:  this.datePipe.transform(this.dateValue, 'HH:mm'),
        event: e,
      });
    }else{
      this.keyUp.emit({
        data:  this.datePipe.transform(this.dateValue, 'yyyy-MM-ddTHH:mm'),
        event: e,
      });
    }*/
  }

}
